import { render, staticRenderFns } from "./download-btn.vue?vue&type=template&id=063cd5e2&scoped=true&"
import script from "./download-btn.vue?vue&type=script&lang=js&"
export * from "./download-btn.vue?vue&type=script&lang=js&"
import style0 from "./download-btn.vue?vue&type=style&index=0&id=063cd5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cd5e2",
  null
  
)

export default component.exports